/* Native variant selection only: no custom cart, checkout, price, inventory or payment behavior. */
(() => {
  'use strict';
  if (window.__novocanvasLipLinerInitialized) return;
  window.__novocanvasLipLinerInitialized = true;
  function initialize(root) {
    if (root.dataset.nclReady) return;
    root.dataset.nclReady = 'true';
    const productArea = root.closest('[data-product-featured]') || root.closest('.shopify-section');
    const form = productArea && productArea.querySelector('form[data-type="add-to-cart-form"]');
    let variants = [];
    try {
      const source = root.querySelector('[data-ncl-variants]');
      const parsed = source && JSON.parse(source.textContent);
      if (Array.isArray(parsed)) variants = parsed;
    } catch (error) { /* Native selectors still work if JSON is unavailable. */ }
    const cards = Array.from(root.querySelectorAll('.shade-card[data-ncl-shade]'));
    const shadeColors = {
      '01 Touch Me': '#c77562',
      '02 Untamable': '#c58e79',
      '03 Whisper': '#af6372',
      '04 Taboo Edge': '#ad5847',
      '05 Possessive': '#9b4a3b',
      '06 Fall Into': '#9d344f',
      '07 Darjeeling': '#785147',
      '08 Morocco': '#aa4742'
    };
    function enhanceNativeSwatches() {
      if (!form) return;
      const picker = form.querySelector('[data-swatch-option][data-id="0"]');
      if (!picker) return;
      picker.classList.add('ncl-swatch-picker');
      picker.querySelectorAll('[data-swatch-item]').forEach(item => {
        const name = item.dataset.value;
        if (!shadeColors[name]) return;
        item.style.setProperty('--ncl-swatch-color', shadeColors[name]);
        item.setAttribute('title', name);
        item.setAttribute('aria-label', name);
      });
    }
    function selectedNativeShade() {
      if (!form) return null;
      const id = form.querySelector('[name="id"]');
      const variant = id && variants.find(item => String(item.id) === String(id.value));
      return variant && (variant.option1 || (variant.options && variant.options[0]));
    }
    function syncCards(shade) {
      cards.forEach(card => {
        const selected = card.dataset.nclShade === shade;
        card.classList.toggle('selected', selected);
        if (selected) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
    }
    root.addEventListener('click', event => {
      const card = event.target.closest('.shade-card[data-ncl-shade]');
      if (!card || !root.contains(card) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      let selected = false;
      if (form) {
        const swatch = Array.from(form.querySelectorAll('[data-swatch-option][data-id="0"] [data-swatch-item]')).find(item => item.dataset.value === card.dataset.nclShade);
        if (swatch) { swatch.click(); selected = true; }
        else {
          const matches = variants.filter(item => (item.option1 || (item.options && item.options[0])) === card.dataset.nclShade);
          const nativeSelect = form.querySelector('select[name="id"]');
          if (matches.length === 1 && nativeSelect && Array.from(nativeSelect.options).some(option => option.value === String(matches[0].id))) {
            nativeSelect.value = String(matches[0].id);
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            selected = true;
          }
        }
      }
      if (selected) syncCards(card.dataset.nclShade);
      const gallery = productArea && productArea.querySelector('[id^="MediaGallery-"]');
      const target = window.matchMedia('(max-width: 749px)').matches ? (gallery || productArea || form) : (productArea || form);
      if (target) window.setTimeout(() => {
        const rect = target.getBoundingClientRect();
        const mobileGalleryOffset = gallery && target === gallery ? Math.max(0, rect.height - window.innerHeight * .58) : 0;
        const top = Math.max(0, rect.top + window.scrollY + mobileGalleryOffset - 72);
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }, 180);
    });
    if (form) {
      enhanceNativeSwatches();
      form.addEventListener('change', () => syncCards(selectedNativeShade()));
      form.addEventListener('click', event => {
        const swatch = event.target.closest('[data-swatch-option][data-id="0"] [data-swatch-item]');
        if (swatch && form.contains(swatch)) {
          syncCards(swatch.dataset.value);
          window.requestAnimationFrame(enhanceNativeSwatches);
        }
      });
      syncCards(selectedNativeShade());
    }
  }
  function initializeWithin(container) {
    if (container.matches && container.matches('[data-ncl-details]')) initialize(container);
    container.querySelectorAll('[data-ncl-details]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();
